/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementYandexOptions, FxIdDomainSettingsAdvertisementYandexOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementYandexOptionsToJSON, } from './FxIdDomainSettingsAdvertisementYandexOptions';
export function FxIdDomainSettingsAdvertisementOptionsYandexFromJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsYandexFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsYandexFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementYandexOptions(json)) {
        return FxIdDomainSettingsAdvertisementYandexOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementOptionsYandexToJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsYandexToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsYandexToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementYandexOptions(value)) {
        return FxIdDomainSettingsAdvertisementYandexOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementOptionsYandex.js.map